import { createAsyncThunk } from '@reduxjs/toolkit';

import type {
  PorteiroLotesConsulta,
  PorteiroLotesResposta,
  PorteiroObservabilidadeConsulta,
  PorteiroObservabilidadeResposta,
} from '../../types/porteiroObservabilidade';

import { porteiroObservabilidadeService } from './services';

export const fetchPorteiroObservabilidade = createAsyncThunk<
  PorteiroObservabilidadeResposta,
  PorteiroObservabilidadeConsulta,
  { rejectValue: string }
>('porteiroObservabilidade/fetch', async (consulta, { signal, rejectWithValue }) => {
  try {
    return await porteiroObservabilidadeService.get(consulta, signal);
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : 'Erro ao carregar a observabilidade do porteiro',
    );
  }
});

/**
 * Página de lotes do filtro. Sem reducer, como o lookup de escritórios (`searchEscritoriosLookup`):
 * a lista é estado local do select, que acumula as páginas e descarta ao trocar a busca.
 */
export const buscarLotesDoPorteiro = createAsyncThunk<
  PorteiroLotesResposta,
  PorteiroLotesConsulta,
  { rejectValue: string }
>('porteiroObservabilidade/lotes', async (consulta, { rejectWithValue }) => {
  try {
    return await porteiroObservabilidadeService.lotes(consulta);
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : 'Erro ao carregar os lotes do escritório',
    );
  }
});
